import React from 'react';
import HelpContent from './HelpContent';
import HidrogenoMotrices from 'img/maritimo_hidrogeno.PNG';

const HidrogenoMotricesHelp = () => (
  <HelpContent>
    <h1>Uso de hidrógeno en motores de la industria y minería</h1>
    <p>
    Esta medida evalúa el impacto del reemplazo de combustibles fósiles por hidrógeno en los usos motrices de la industria y minería. 
    La introducción de hidrógeno verde en la industria y minería (excluye cobre) a través del uso maquinaria impulsada a partir de la tecnología de celdas de combustible busca 
    implementar soluciones que posibiliten la transición de los vehículos de transporte y maquinaria empleados en la industria, que actualmente utilizan 
    combustibles fósiles; a la vez de aprovechar la mayor eficiencia que caracteriza el uso de hidrogeno verde.
    </p>
    <p>
    <strong>Trayectoria 1:</strong> 
    </p>
    <p>
    Industria: la participación de hidrógeno en usos motrices es de 0,1% en 2035, un 1,3% en 2040 y alcanza un 6,9% en 2050.
    </p>
    <p>
    Minería: la participación de hidrógeno en usos motrices es de 0,04% en 2035, un 3,2% en 2040 y alcanza un 28,4% en 2050.
    </p>
    <p>
    <strong>Trayectoria 2:</strong> 
    </p>
    <p>
    Industria: la participación de hidrógeno en usos motrices es de 0,1% en 2035, un 1,3% en 2040 y alcanza un 16,9% en 2050.
    </p>
    <p>
    Minería: la participación de hidrógeno en usos motrices es de 0,04% en 2035, un 3,2% en 2040 y alcanza un 38,2% en 2050.
    </p>
  </HelpContent>
);

export default HidrogenoMotricesHelp;
